// This file is generated.
export var version = '1.77.0';
//# sourceMappingURL=version.js.map